<template>
    <div>
        <v-layout align-center class="mb-3">
            <v-text-field
                v-model="searchKey"
                prepend-inner-icon="mdi-magnify"
                :placeholder="$t('searchBy.wordsOrReplacement')"
                hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" @click="createItem" v-if="isEditable">{{$t('new')}}</v-btn>
        </v-layout>
        <SimpleDataTable
            :headers="headers"
            :items="filterItemList"
            :pagination="pagination"
        >
            <template v-slot:action="props">
                <v-btn icon @click="editItem(props.item)"><v-icon>mdi-pencil</v-icon></v-btn>
                <v-btn icon @click="deleteItem(props.item)"><v-icon>mdi-delete</v-icon></v-btn>
            </template>
            <template v-slot:synonym="{item}">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">{{$utils.limitStringLength(item.meaning.join('; '), 70)}}</span>
                    </template>
                    <div>
                        <div v-for="(item, i) in item.meaning" :key="i">{{item}}</div>
                    </div>
                </v-tooltip>
            </template>
        </SimpleDataTable>
    </div>
</template>

<script>
import SimpleDataTable from "@/modules/fptai/components/SimpleDataTable";
import { mapState } from "vuex";
import { ScenarioEventBus, ScenarioEventBusType } from "@/views/Scenario/scenario.eventbus";
import NLP_Service from "@/services/nlp.service";
import NLPItemList from "@/views/Scenario/nlp/NLPItemList";
import ScenarioService from "@/services/scenario.service";

export default {
    name: "KeywordList",
    components: { SimpleDataTable },
    extends: NLPItemList,
    computed: {
        ...mapState({
            itemList: state => state.scenario.dictionaryList
        }),
        filterItemList () {
            let search = this.$utils.nonAccentVietnamese(this.searchKey)
            if (search) {
                return this.itemList.filter(item =>
                    this.$utils.nonAccentVietnamese(item.word).includes(search) ||
                    this.$utils.nonAccentVietnamese(item.meaning.join(',')).includes(search)
                )
            }
            return this.itemList
        },
        headers () {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('words'),
                    value: 'word'
                },
                {
                    text: this.$t('replacement'),
                    value: 'meaning',
                    type: 'custom',
                    id: 'synonym'
                },
                {
                    text: this.$t('action'),
                    value: 'action',
                    type: 'custom',
                    id: 'action',
                    visible: this.isEditable
                }
            ])
        },
        isEditable: () => ScenarioService.isEditable()
    },
    methods: {
        searchItem () {
            this.$store.dispatch(this.$actionTypes.scenario.GET_DICTIONARY_LIST, this.$route.params.scenarioId)
        },
        createItem () {
            ScenarioEventBus.$emit(ScenarioEventBusType.CREATE_DICTIONARY, {
                item: null,
                resolve: this.searchItem
            })
        },
        editItem (item) {
            ScenarioEventBus.$emit(ScenarioEventBusType.CREATE_DICTIONARY, {
                item,
                resolve: this.searchItem
            })
        },
        deleteItem (item) {
            this.$appService.confirm(this.$t('confirmDelete', { item: this.$t('keyword') + ': ' + item.word })).then(
                () => {
                    let i18n = {
                        action: this.$t('delete'),
                        item: this.$t('dictionary')
                    }
                    this.$appService.showLoading()
                    NLP_Service.DictionaryService.delete(
                        this.$route.params.scenarioId,
                        item.code
                    ).then(
                        () => {
                            this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                            this.searchItem()
                        },
                        this.$appService.handleRequestError(this.$t('actionFailed', i18n))
                    ).finally(this.$appService.hideLoading)
                }
            )
        }
    }
}
</script>

<style scoped>

</style>
